









import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
@Component
export default class ComponentProductPackaging extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) private items!: string[]
}
